import React, { useEffect, useState } from "react";
import { FileSpreadsheet, Sparkles, Loader2, Download } from "lucide-react";
import { Breadcrumb, GradientPanel } from "../components/common";
import api from "../lib/api";

const VatReturns = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/vat-return"); setData(data); }
      catch {} finally { setLoading(false); }
    })();
  }, []);

  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "VAT Returns" }]} />
      <GradientPanel>
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-500 flex items-center justify-center text-white"><FileSpreadsheet size={20} /></div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">VAT Returns</h1>
              <p className="text-sm text-gray-500 mt-1">Auto-prepared by the Reconciliation &amp; VAT Analytics agent — continuously, with zero manual entry.</p>
            </div>
          </div>
          <button className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 border border-blue-200 hover:bg-blue-50 px-4 py-2 rounded-lg transition"><Download size={15} /> Export return</button>
        </div>

        {loading ? (
          <div className="py-16 flex justify-center"><Loader2 className="animate-spin text-indigo-500" size={28} /></div>
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
              <Stat label="Invoices in period" value={data.count} />
              <Stat label="Net VAT payable" value={`AED ${data.net_payable.toFixed(2)}`} accent />
              <Stat label="Period" value={data.period === "all" ? "All time" : data.period} />
              <Stat label="Preparation" value="Automatic" />
            </div>

            <div className="mt-6 rounded-2xl border border-gray-100 overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-gray-50"><tr className="text-left text-gray-500">
                  <th className="py-3 px-4 font-semibold w-16">Box</th>
                  <th className="py-3 px-4 font-semibold">Description</th>
                  <th className="py-3 px-4 font-semibold text-right">Amount (AED)</th>
                  <th className="py-3 px-4 font-semibold text-right">VAT (AED)</th>
                </tr></thead>
                <tbody>
                  {data.boxes.map((b) => (
                    <tr key={b.box} className="border-t border-gray-50 hover:bg-gray-50/60">
                      <td className="py-3 px-4 font-semibold text-gray-700">{b.box}</td>
                      <td className="py-3 px-4 text-gray-700">{b.label}</td>
                      <td className="py-3 px-4 text-right text-gray-700">{b.amount.toFixed(2)}</td>
                      <td className="py-3 px-4 text-right font-medium text-indigo-600">{b.vat.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-4 rounded-xl bg-gradient-to-br from-violet-50 to-fuchsia-50 border border-violet-100 p-4">
              <p className="text-[11px] font-bold text-violet-600 flex items-center gap-1.5 mb-1"><Sparkles size={12} /> AGENT NARRATIVE</p>
              <p className="text-sm text-gray-600">{data.narrative}</p>
            </div>
          </>
        )}
      </GradientPanel>
    </div>
  );
};

const Stat = ({ label, value, accent }) => (
  <div className="rounded-xl border border-gray-100 bg-white p-4">
    <p className="text-xs text-gray-400">{label}</p>
    <p className={`text-xl font-bold mt-1 ${accent ? "text-indigo-600" : "text-gray-900"}`}>{value}</p>
  </div>
);

export default VatReturns;
